import React from 'react';
import { Box, Flex, Icon } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

const Title = ({ icon, children, extra, ...props }) => (
  <Box
    px="5"
    py="4"
    borderBottom="1"
    borderColor="greys.alto"
    {...props} // eslint-disable-line react/jsx-props-no-spreading
  >
    <Flex alignItems="center">
      {icon &&
        (typeof icon === 'string' ? (
          <Icon data-testid="ICON" name={icon} />
        ) : (
          icon
        ))}
      <Box flex="1" ml={icon && 3}>
        {children}
      </Box>
      {extra && <Box>{extra}</Box>}
    </Flex>
  </Box>
);

Title.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired,
  extra: PropTypes.node,
  ...Box.propTypes,
};

export default Title;
